import React from 'react';

export default function BlogDivider({ data }) {
  const { style = 'line' } = data;

  if (style === 'dots') {
    return (
      <div className="blog-divider blog-divider--dots">
        <span /><span /><span />
      </div>
    );
  }

  if (style === 'space') {
    return <div className="blog-divider blog-divider--space" />;
  }

  return <hr className="blog-divider blog-divider--line" />;
}
